var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app-bar",
    { attrs: { app: "", height: "80" } },
    [
      _c(
        "v-container",
        [
          _vm.jeDealer
            ? _c(
                "router-link",
                {
                  staticStyle: { position: "absolute", left: "14px" },
                  style: _vm.isMobile ? { top: "15px" } : { top: "20px" },
                  attrs: { to: "/" }
                },
                [
                  _c("img", {
                    staticClass: "mr-4",
                    attrs: {
                      srcset: require("../assets/img/logo-tl" +
                        (_vm.isMobile ? "-mobil" : "") +
                        (_vm.$vuetify.theme.dark ? "-dark" : "-light") +
                        ".svg")
                    }
                  })
                ]
              )
            : _c(
                "a",
                {
                  staticStyle: { position: "absolute", left: "14px" },
                  style: _vm.isMobile ? { top: "15px" } : { top: "20px" },
                  on: {
                    click: function($event) {
                      return _vm.setExternalUrl({ url: _vm.logoUrl })
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "mr-4",
                    attrs: {
                      srcset: require("../assets/img/logo-tl" +
                        (_vm.isMobile ? "-mobil" : "") +
                        (_vm.$vuetify.theme.dark ? "-dark" : "-light") +
                        ".svg")
                    }
                  })
                ]
              ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _vm.jeDealer
                    ? _c(
                        "v-tabs",
                        {
                          staticClass: "pa-0 app-header-nav",
                          staticStyle: { height: "80px" },
                          attrs: { "hide-slider": "" }
                        },
                        [
                          _c(
                            "v-tab",
                            {
                              staticClass: "text-none",
                              attrs: { to: "/obchodne-pripady" }
                            },
                            [_vm._v("Obchodné prípady")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.jeDealer && !_vm.isMobile
                    ? _c("h2", { staticClass: "pa-0 app-header-nav" }, [
                        _vm._v("Nové financovanie")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c("v-col", { attrs: { cols: "6" } }, [
                _vm.jeDealer
                  ? _c(
                      "div",
                      { staticClass: "app-header-search" },
                      [
                        _c("v-text-field", {
                          attrs: {
                            outlined: "",
                            placeholder:
                              "Vyhľadávať Nájomcu, Obchodný prípad alebo Zmluvu",
                            "append-icon": "mdi-magnify"
                          },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.searchFullText($event)
                            },
                            input: function(val) {
                              return _vm.setFullTextQuery(val)
                            }
                          },
                          model: {
                            value: _vm.query,
                            callback: function($$v) {
                              _vm.query = $$v
                            },
                            expression: "query"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                position: "absolute",
                right: "0px",
                top: "15px"
              }
            },
            [
              _vm.jePrihlaseny
                ? [
                    _vm.jeDealer
                      ? [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-3 btn-primary",
                              staticStyle: { "margin-top": "5px" },
                              attrs: { to: "/obchodny-pripad" }
                            },
                            [_vm._v("Nový prípad")]
                          ),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                transition: "slide-x-transition",
                                "offset-y": "",
                                rounded: "xl"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "mr-3 app-header-menu-button",
                                                attrs: { dark: "", icon: "" }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass:
                                                  "app-header-menu-button",
                                                attrs: { size: "35" }
                                              },
                                              [_vm._v("$avatar")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                574867641
                              )
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.user.name) +
                                                " (" +
                                                _vm._s(_vm.user.login) +
                                                ")"
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              " ID Operatora : " +
                                                _vm._s(_vm.user.id)
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm.user.admin
                                        ? _c(
                                            "v-list-item",
                                            { attrs: { to: "/administracia" } },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v("Administrácia")
                                              ])
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.user.frmLogged
                                        ? _c(
                                            "v-list-item",
                                            { attrs: { to: "/zmena-hesla" } },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v("Zmeniť heslo")
                                              ])
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.user.branchNumber
                                        ? _c(
                                            "v-list-item",
                                            {
                                              attrs: {
                                                to: "/zmena-hesla-signatus"
                                              }
                                            },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v("Zmeniť Signatus heslo")
                                              ])
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.user.frmLogged
                                        ? _c(
                                            "v-list-item",
                                            { attrs: { to: "/logout" } },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v("Odhlásiť")
                                              ])
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "v-list",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-list-item-group",
                                        {
                                          attrs: {
                                            multiple: "",
                                            "active-class": ""
                                          },
                                          model: {
                                            value: _vm.settings,
                                            callback: function($$v) {
                                              _vm.settings = $$v
                                            },
                                            expression: "settings"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.switchTheme()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-item-action",
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass:
                                                      "dynamic_check_box",
                                                    attrs: {
                                                      "input-value": this
                                                        .$vuetify.theme.dark
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v("Dark theme")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm.envDebug
                                            ? _c(
                                                "v-list-item",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setDebug(
                                                        !_vm.debug
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-action",
                                                    [
                                                      _c("v-checkbox", {
                                                        staticClass:
                                                          "dynamic_check_box",
                                                        attrs: {
                                                          "input-value":
                                                            _vm.debug
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v("Debug mode")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "ml-10px mb-5px text--disabled"
                                    },
                                    [_vm._v("ver. " + _vm._s(_vm.version))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : [
                          !_vm.isMobile
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-secondary",
                                  staticStyle: { "margin-top": "5px" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setExternalUrl({
                                        url: _vm.clientZoneUrl
                                      })
                                    }
                                  }
                                },
                                [_vm._v("Klientská zóna")]
                              )
                            : _vm._e(),
                          _c(
                            "v-menu",
                            {
                              staticClass: "user-menu",
                              attrs: {
                                "content-class": "user-setting-menu",
                                "close-on-content-click": false
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "ml-3",
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-self": "center",
                                                  padding:
                                                    "0px 13px 0px 21px !important",
                                                  width: "302px"
                                                }
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            !_vm.isMobile
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "mr-3 app-header-menu-button",
                                                    attrs: { size: "48" }
                                                  },
                                                  [_vm._v("$avatar")]
                                                )
                                              : _vm._e(),
                                            !_vm.isMobile
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "grid"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "f18 white100 text-overflow"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentProfileName
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "f14 gs100 text-overflow"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.user.name)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            !_vm.isMobile
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "primary--text pl-12px",
                                                    staticStyle: {
                                                      "margin-left": "auto"
                                                    }
                                                  },
                                                  [_vm._v(" mdi-chevron-down ")]
                                                )
                                              : [
                                                  !_vm.showMenu
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          staticClass:
                                                            "primary--text pt-13px pr-12px",
                                                          staticStyle: {
                                                            "margin-left":
                                                              "auto"
                                                          }
                                                        },
                                                        [_vm._v(" mdi-menu ")]
                                                      )
                                                    : _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "mobile-close-button"
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticStyle: {
                                                                color: "white"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " mdi-close "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                ]
                                          ],
                                          2
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3572689284
                              ),
                              model: {
                                value: _vm.showMenu,
                                callback: function($$v) {
                                  _vm.showMenu = $$v
                                },
                                expression: "showMenu"
                              }
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  style: !_vm.isMobile
                                    ? { width: "300px" }
                                    : null
                                },
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "pa-0" },
                                    [
                                      _vm.isMobile
                                        ? _c(
                                            "v-list-item",
                                            { staticClass: "menu-header" },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "btn-secondary",
                                                  staticStyle: {
                                                    "margin-top": "5px",
                                                    width: "100%",
                                                    height: "47px"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setExternalUrl(
                                                        {
                                                          url: _vm.clientZoneUrl
                                                        }
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Klientská zóna")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-list-item",
                                        {
                                          staticClass: "menu-header",
                                          on: {
                                            click: function($event) {
                                              !_vm.isMobile &&
                                                (_vm.showMenu = false)
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-self": "center"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "mr-3 app-header-menu-button",
                                                    attrs: { size: "48" }
                                                  },
                                                  [_vm._v("$avatar")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "grid"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "f18 white100 text-overflow",
                                                        staticStyle: {
                                                          "align-self":
                                                            "center",
                                                          "line-height": "1.5"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentProfileName
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "f14 gs100 text-overflow",
                                                        staticStyle: {
                                                          "align-self":
                                                            "center",
                                                          "line-height": "1.5"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.user.name)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                !_vm.isMobile
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "primary--text pl-12px",
                                                        staticStyle: {
                                                          "margin-left": "auto"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " mdi-chevron-up"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _c("v-divider"),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.setExternalUrl({
                                                url:
                                                  _vm.clientZoneProfileSettingsUrl
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-cog-outline")
                                              ])
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              "Nastavenia klientského profilu "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm.allProfiles.length > 1
                                        ? [
                                            _c("v-divider"),
                                            _c(
                                              "v-list-item",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  { staticClass: "f12" },
                                                  [
                                                    _vm._v(
                                                      "Prepnúť sa do iného klientskeho profilu"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._l(_vm.allProfiles, function(
                                              item,
                                              index
                                            ) {
                                              return [
                                                index < 3
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        key: index,
                                                        class: {
                                                          "active-item":
                                                            item.idProfilu ==
                                                            _vm.user.profileId
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.changeProfile(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-action",
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.idProfilu ==
                                                                    _vm.user
                                                                      .profileId
                                                                    ? "mdi-radiobox-marked"
                                                                    : "mdi-radiobox-blank"
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "text-overflow"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.nazov)
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }),
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setExternalUrl({
                                                      url:
                                                        _vm.clientZoneProfilesUrl
                                                    })
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list-item-action",
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "mdi-dots-horizontal"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticStyle: {
                                                      display: "flex"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "align-self": "center"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Moje klientské profily (" +
                                                            _vm._s(
                                                              _vm.allProfiles
                                                                .length
                                                            ) +
                                                            ")"
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "auto"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-chevron-right "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.getCreateProfileLink()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c("v-icon", [_vm._v("mdi-plus")])
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v("Pridať nový profil")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "v-list",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-list-item-group",
                                        {
                                          attrs: {
                                            multiple: "",
                                            "active-class": ""
                                          },
                                          model: {
                                            value: _vm.settings,
                                            callback: function($$v) {
                                              _vm.settings = $$v
                                            },
                                            expression: "settings"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item",
                                            {
                                              staticClass: "switch-item",
                                              on: {
                                                click: function($event) {
                                                  return _vm.switchTheme()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    [
                                                      _c("v-switch", {
                                                        attrs: {
                                                          "input-value": this
                                                            .$vuetify.theme
                                                            .dark,
                                                          inset: "",
                                                          label: "Tmavá téma",
                                                          "hide-details": ""
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm.envDebug
                                            ? _c(
                                                "v-list-item",
                                                {
                                                  staticClass: "switch-item",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setDebug(
                                                        !_vm.debug
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        [
                                                          _c("v-switch", {
                                                            attrs: {
                                                              "input-value":
                                                                _vm.debug,
                                                              inset: "",
                                                              label:
                                                                "Debug mode",
                                                              "hide-details": ""
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.user.frmLogged
                                            ? _c(
                                                "v-list-item",
                                                {
                                                  staticClass: "logout-item",
                                                  attrs: { to: "/logout" }
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-action",
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("mdi-power")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-list-item-title", [
                                                    _vm._v("Odhlásiť sa")
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.envDebug
                                    ? [
                                        _c("v-divider"),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-10px mb-5px text--disabled",
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function($event) {
                                                return _vm.$router.push(
                                                  "/version"
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Verzia")]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ]
                  ]
                : [
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-3 btn-secondary",
                        staticStyle: {
                          "margin-top": "5px",
                          height: "32px !important"
                        },
                        on: {
                          click: function($event) {
                            return _vm.loginFromAnonymous()
                          }
                        }
                      },
                      [_vm._v("Prihlásiť sa")]
                    )
                  ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }